import type { Extensions } from '@tiptap/react';

import { TextAlign } from '@tiptap/extension-text-align';
import Typography from '@tiptap/extension-typography';

/**
 * A simplified set of extensions for the Tiptap editor.
 * Includes Typography and text alignment for headings and paragraphs.
 */
export const simpleExtensionSet: Extensions = [
  Typography,
  TextAlign.configure({
    types: ['heading', 'paragraph', 'image-node', 'video-node', 'table'],
  }),
];
